import { TranslocoService } from '@jsverse/transloco';
import { DialogService } from 'primeng/dynamicdialog';
import { ModalHelperService } from '../../../../../../services/modal-helper.service';
import { CampaignPlanningComponent, PlanningDialogData } from './campaign-planning.component';

interface PlanningDialogDeps {
  dialogService: DialogService;
  modalHelper: ModalHelperService;
  translate: TranslocoService;
}

const PLANNING_DIALOG_HEADER_KEY: Record<PlanningDialogData['mode'], string> = {
  measures: 'entities.campaign.messages.planMeasures',
  auscultations: 'entities.auscultationInformation.messages.planningTitle',
};

// Opens the shared planning catalogue dialog (full catalogue, plan/unplan). Centralizes the
// per-mode header mapping and the open/onClose wiring shared by the campaign measures and
// auscultation tabs and the campaign-model planning tab; each caller only supplies its data
// and reload callback.
export function openCampaignPlanningDialog(deps: PlanningDialogDeps, data: PlanningDialogData, onClose: () => void): void {
  const ref = deps.dialogService.open(
    CampaignPlanningComponent,
    deps.modalHelper.getLargeConfig({ header: deps.translate.translate(PLANNING_DIALOG_HEADER_KEY[data.mode]), height: '80vh', data }),
  );
  ref.onClose.subscribe(() => onClose());
}
